import React from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"
import moment from "moment"

import {Text, View, StyleSheet} from "@react-pdf/renderer"

const styles = StyleSheet.create({
  container: {
    paddingTop: 50,
    fontFamily: "Roboto",
    color: "#0D3366"
  },
  tableTitle: {
    fontSize: 14,
    paddingBottom: 20
  },
  withBorderBottom: {
    borderBottomWidth: 1,
    borderBottomColor: "#979797",
    borderBottomStyle: "solid"
  },
  tableHeader: {
    flexDirection: "row",
    marginBottom: 10,
    fontSize: 11,
    color: "#979797"
  },
  tableLine: {
    flexDirection: "row",
    paddingBottom: 5,
    marginBottom: 5,
    fontSize: 11,
    color: "#0D3366"
  },
  tableElement: {
    flex: 1
  }
})

const Table = ({number, stock_outs, usingLotNumber}) => (
  <View style={styles.container}>
    <View style={styles.tableTitle}>
      <Text>Lieferschein «{number}»</Text>
    </View>
    <View style={{...styles.tableHeader, ...styles.withBorderBottom}}>
      <Text style={styles.tableElement}>Artikelstamm</Text>
      <Text style={styles.tableElement}>Prüfdatum</Text>
      <Text style={styles.tableElement}>Lieferdatum</Text>
      {usingLotNumber && <Text style={styles.tableElement}>Charge</Text>}
      <Text style={styles.tableElement}>Menge</Text>
      <Text style={styles.tableElement}>Einheit</Text>
    </View>
    {stock_outs.map(stock_out => (
      <View
        key={stock_out.id}
        style={{...styles.tableLine, ...styles.withBorderBottom}}
      >
        <Text style={styles.tableElement}>{stock_out.article.name}</Text>
        <Text style={styles.tableElement}>{stock_out.article.expiry_date}</Text>
        <Text style={styles.tableElement}>
          {moment(stock_out.created_at).format("DD.MM.YYYY")}
        </Text>
        <Text style={styles.tableElement}>{stock_out.article.lot_number}</Text>
        <Text style={styles.tableElement}>{stock_out.quantity}</Text>
        <Text style={styles.tableElement}>{stock_out.article.unit}</Text>
      </View>
    ))}
  </View>
)

Table.propTypes = {
  number: PropTypes.string.isRequired,
  stock_outs: PropTypes.array.isRequired
}

const mapStateToProps = ({auth}) => {
  const {user} = auth
  const {settings} = user
  const {usingLotNumber} = settings
  return {usingLotNumber}
}

export default connect(mapStateToProps)(Table)



// WEBPACK FOOTER //
// ./src/components/pdf/delivery_note/Table.js